import { debounce } from 'stimulus_reflex/javascript/utils.js'
import ApplicationController from './application_controller.js'

export default class extends ApplicationController {
	static targets = [ "form", "list" ]

	connect() {
		super.connect()
		// TODO: Debouonce to limit the number of reflex calls
		this.filter = debounce(this.filter.bind(this), 300)
  
    // Connection state logging
    // console.log("Consumer state:", this.application.consumer?.connection?.state)
    // console.log("Is connected?", this.application.consumer?.connection?.isOpen())

    this.element.addEventListener('stimulus-reflex:before', this.showLoading.bind(this))
    this.element.addEventListener('stimulus-reflex:after', this.hideLoading.bind(this))
    this.element.addEventListener('stimulus-reflex:error', this.hideLoading.bind(this))
		}

  disconnect() {
    this.element.removeEventListener('stimulus-reflex:before', this.showLoading)
    this.element.removeEventListener('stimulus-reflex:after', this.hideLoading)
    this.element.removeEventListener('stimulus-reflex:error', this.hideLoading)
  }

		showLoading() {
			const overlay = this.formTarget.querySelector('.loading-overlay')
			if (overlay) {
				overlay.classList.add('active')
			}
		}

		hideLoading() {
			const overlay = this.formTarget.querySelector('.loading-overlay')
			if (overlay) {
				overlay.classList.remove('active')
			}
		}

		filter(event) {
			event.preventDefault()

			const strategies = Array.from(
				this.formTarget.querySelectorAll('input[name="filter[strategy][]"]:checked')
			).map(el => el.value)

			const positioning = Array.from(
				this.formTarget.querySelectorAll('input[name="filter[positioning][]"]:checked')
			).map(el => el.value)

			const min_investment = Array.from(
				this.formTarget.querySelectorAll('input[name="filter[min_investment][]"]:checked')
			).map(el => el.value)

			const typologie = Array.from(
				this.formTarget.querySelectorAll('input[name="filter[typologie][]"]:checked')
			).map(el => el.value)

			const fiscality = Array.from(
				this.formTarget.querySelectorAll('input[name="filter[fiscality][]"]:checked')
			).map(el => el.value)

			this.stimulate("FundsReflex#filter", { strategies, positioning, min_investment, typologie, fiscality })
			console.log("selected strategies:", strategies) // ["pe_primary","pe_secondary"]
		}

		reset(event) {
			event.preventDefault();
			const checkedBoxes = this.formTarget.querySelectorAll('input:checked');
			checkedBoxes.forEach(box => box.checked = false);
			this.stimulate("FundsReflex#reset");
		}
}